<template>
    <div class="page">
        <toolbar-system></toolbar-system>
        <progress-system :isLoad="progress"></progress-system>
        <alertbar-system v-if="AlertbarShow != null" :alertbar="AlertbarShow"></alertbar-system>
        <v-container v-show="cursosAbertos != null" grid-list-lg fluid>
            <v-layout wrap>
                <v-flex v-for="curso in cursosAbertos" :key="curso.index" xs12 sm6 md4 lg4 xl3>
                  <v-card class="animated fadeIn">
                        <!-- <v-img src="https://picsum.photos/id/180/300/100"></v-img> -->
                        <v-card-title>
                            <div class="title text-truncate">{{curso.Disciplina}}</div>
                        </v-card-title>
                        <v-card-text>
                            <div>
                              <strong class="blue--text text--darken-1">Início:</strong> {{$moment(curso.DataInicial).format('LL')}}<br>
                              <strong class="blue--text text--darken-1">Código:</strong> {{curso.TurmaDescricao}}
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn class="blue--text text--draken-1" :href="'/aluno/programacao_academica/' + curso.Codigo" flat dark>Mais detalhes</v-btn>
                            <v-btn v-if="curso.Matriculado == null && curso.Esgotado == 0" class="orange--text text--draken-1" :loading="btnInsProgress" @click="modalInscricao(curso, curso.Codigo)" flat dark>Inscreva-se</v-btn>
                            <button v-else-if="curso.Matriculado == null &&  curso.Esgotado == 1" class="grey--text text--darken-1 pl-2" :loading="btnInsProgress" :disabled="true" flat dark>VAGAS ESGOTADAS</button>

                            <v-tooltip v-else bottom>
                                <template v-slot:activator="{ on }">
                                <v-btn :href="'/aluno/meus_cursos'" class="green--text text--draken-1 pl-0 ml-0" v-on="on" flat dark>
                                    <v-icon left>mdi mdi-check-all</v-icon>
                                  <span> Pré-inscrito </span>
                                </v-btn>
                                </template>
                                <span>Acompanhe a efetivação da sua matrícula em "Meus Cursos"</span>
                            </v-tooltip>

                        </v-card-actions>

                    </v-card>

                    <v-dialog
                        v-model="modalInscricaoAbrir"
                        width="100%"
                        persistent
                        scrollable
                        :fullscreen="$vuetify.breakpoint.xsOnly"
                    >
                        <v-card width="100%">

                            <v-card-title class="text-h6 grey lighten-2" style="overflow:hidden;">
                                <v-row>
                                    <h3>Para realizar a incrição complemente seus dados</h3>
                                </v-row>
                            </v-card-title>

                            <v-divider/>

                            <v-card-text>
                                <v-row cols="12">

                                    <v-col
                                        class="ml-auto"
                                    >
                                        <v-text-field
                                            class="ml-auto"
                                            label="Nome da mãe"
                                            v-model="nomeDaMae"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        class="ml-auto"
                                    >
                                        <v-text-field
                                            class="ml-auto"
                                            label="Nome do pai"
                                            v-model="nomeDoPai"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        class="ml-auto"
                                    >
                                        <v-autocomplete
                                            class="ml-auto"
                                            v-model="escolasMonitoramentoSelect"
                                            label="Selecionar escola"
                                            item-text="Escola"
                                            item-value="IdEscola"
                                            :items="escolasMonitoramento"
                                            :rules="[rules.required]"
                                            required
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>

                                <v-row cols="12">
                                    <v-col
                                        class="ml-auto"
                                    >
                                        <v-text-field
                                        class="ml-auto"
                                        label="CEP"
                                        v-model="cep"
                                        :rules="[rules.required]"
                                        @keyup="searchCep()"
                                        ></v-text-field>

                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                        class="ml-auto"
                                        label="Logradouro"
                                        v-model="logradouro"
                                        :rules="[rules.required]"
                                        @keyup="searchCep()"
                                        ></v-text-field>

                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                        class="ml-auto"
                                        label="Bairro"
                                        v-model="bairro"
                                        :rules="[rules.required]"
                                        @keyup="searchCep()"
                                        ></v-text-field>

                                    </v-col>
                                </v-row>
                                <v-row cols="12">
                                    <v-col
                                        class="ml-auto"
                                    >
                                        <v-text-field
                                        class="ml-auto"
                                        label="Cidade"
                                        v-model="cidade"
                                        :rules="[rules.required]"
                                        @keyup="searchCep()"
                                        ></v-text-field>

                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                        class="ml-auto"
                                        label="UF"
                                        v-model="uf"
                                        :rules="[rules.required]"
                                        @keyup="searchCep()"
                                        ></v-text-field>

                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                        class="ml-auto"
                                        label="Número"
                                        v-model="numero"
                                        :rules="[rules.required]"
                                        ></v-text-field>

                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-spacer></v-spacer>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text large @click="closeModal()"> Fechar </v-btn>

                                <v-btn
                                :disabled="!numero"
                                large
                                color="blue darken-1"
                                @click="goInscricaoEnem(curso.curso)"
                                >
                                    Realizar inscrição
                                </v-btn>

                            </v-card-actions>
                        </v-card>

                    </v-dialog>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import ToolbarSystem from '../../../components/ToolbarSystem'
import ProgressSystem from '../../../components/ProgressSystem'
import AlertbarSystem from '../../../components/AlertbarSystem'
export default {
    components:{
        ToolbarSystem,
        ProgressSystem,
        AlertbarSystem
    },
    data () {
        return{
            sideIcon: true,
            cursosAbertos: null,
            escolasMonitoramento: [],
            progress: true,
            AlertbarShow: null,
            btnInsProgress: null,
            quantidade:null,
            cep: null,
            logradouro: null,
            uf: null,
            cidade: null,
            bairro: null,
            escolasMonitoramentoSelect: null,
            nomeDaMae: null,
            nomeDoPai: null,
            numero: null,
            modalInscricaoAbrir: false,
            rules: {
                required: value => !!value || 'Campo é obrigatório',
            },
        }
    },
    methods:{
        getCursosAbertos (){
            let idpessoafisica = localStorage.getItem('idpessoafisica')
            this.axios.get('user/cursoaberto/' + idpessoafisica + '/turmas').then(res => {
                this.cursosAbertos = res.data
            }).finally(()=>{
                this.progress = false
            })
        },
        getEscolas (){
            this.axios.get('escolasMonitoramento').then(res => {
                this.escolasMonitoramento = res.data
            }).finally(()=>{
                this.progress = false
            })
        },
        modalInscricao(item, idCurso) {
            if (item.InscricaoComplemento == 1){
                this.zerarCampos()
                this.getEscolas()
                this.modalInscricaoAbrir = true
            }
            else{
                this.goInscricao(idCurso)
            }
        },
        closeModal(){
            this.modalInscricaoAbrir = false
        },
        searchCep(){
            this.$axios.get(`https://viacep.com.br/ws/${ this.cep.replace(/\D/g, '') }/json/`).then((res) => {

                this.logradouro     = res.data.logradouro;
                this.bairro         = res.data.bairro;
                this.cidade         = res.data.localidade;
                this.uf             = res.data.uf;

            })
        },
        zerarCampos(){
            this.cep                        = null;
            this.logradouro                 = null;
            this.bairro                     = null;
            this.cidade                     = null;
            this.uf                         = null;
            this.nomeDaMae                  = null;
            this.nomeDoPai                  = null;
            this.escolasMonitoramentoSelect = null;
            this.numero                     = null;

        },

        goInscricaoEnem(idCurso) {
              let confirmar = confirm("Deseja realmente realizar pré-inscrição nesse curso?")

              if(confirmar){
                this.btnInsProgress = true
                this.axios.post('user/cursoaberto/registroAlternativo', {
                    curso:          idCurso,
                    nomeDaMae:      this.nomeDaMae,
                    nomeDoPai:      this.nomeDoPai,
                    escola:         this.escolasMonitoramentoSelect,
                    cep:            this.cep,
                    logradouro:     this.logradouro,
                    bairro:         this.bairro,
                    cidade:         this.cidade,
                    uf:             this.uf,
                    numero:         this.numero,
                }).then(res => {
                    this.AlertbarShow = {
                        color: 'green',
                        show: true,
                        time: 10000,
                        text: res.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                    this.getCursosAbertos()
                }).catch((e) => {
                    this.AlertbarShow = {
                        color: 'red',
                        show: true,
                        time: 10000,
                        text: e.response.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                }).finally(() => {
                    this.btnInsProgress = false
                })
              }
          },

        goInscricao(idCurso) {
              let confirmar = confirm("Deseja realmente realizar pré-inscrição nesse curso?")

              if(confirmar){
                this.btnInsProgress = true
                this.axios.post('user/cursoaberto/registro', {
                    curso: idCurso
                }).then(res => {
                    this.AlertbarShow = {
                        color: 'green',
                        show: true,
                        time: 10000,
                        text: res.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                    this.getCursosAbertos()
                }).catch((e) => {
                    this.AlertbarShow = {
                        color: 'red',
                        show: true,
                        time: 10000,
                        text: e.response.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                }).finally(() => {
                    this.btnInsProgress = false
                })
              }
          },
      },
      mounted(){
          this.getCursosAbertos()
      }
}
</script>
<style>

</style>
